<template>
  <div class="tag_list__table">
    <vs-table id="tag__table" class="vs-con-loading__container" stripe search @search="updateSearchQuery" :sst="true" :data="tags">
      <template slot="header">
        <!-- TABLE ACTION ROW -->
        <div class="flex flex-wrap justify-between items-center">
          <!-- ITEMS PER PAGE -->
          <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
            <vs-dropdown vs-trigger-click class="cursor-pointer">
              <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                <span class="mr-2">
                  {{ page * length - (length - (FilteredCount && 1)) }}
                  -
                  {{ FilteredCount - page * length > 0 ? page * length : FilteredCount }}
                  of {{ FilteredCount }} (filtered from {{ total }} total entries)
                </span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <vs-dropdown-menu>
                <vs-dropdown-item @click="handleChangeLength(10)">
                  <span>10</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="handleChangeLength(20)">
                  <span>20</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="handleChangeLength(50)">
                  <span>50</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="handleChangeLength(100)">
                  <span>100</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
        </div>

        <div @click="addMoreTag" class="btn-add-new p-2 mr-4 rounded-lg cursor-pointer flex items-center justify-center font-medium text-base text-primary border border-solid border-primary">
          <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
          <span class="ml-2 text-base text-primary">Get More Tags</span>
        </div>
      </template>

      <template slot="thead">
        <vs-th>Sr#</vs-th>
        <vs-th>Tag No</vs-th>
        <vs-th>Type</vs-th>
        <vs-th>Status</vs-th>
        <vs-th>Commisioned</vs-th>
        <!-- <vs-th>Action</vs-th> -->
      </template>

      <template slot-scope="{ data }" ref="tableBody">
        <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
          <vs-td>
            {{ page * length - (length - i - 1) }}
          </vs-td>
          <vs-td>
            {{ tr.tag_no }}
          </vs-td>
          <vs-td>
            {{ tr.type }}
          </vs-td>
          <vs-td>
            {{ tr.status }}
          </vs-td>
          <vs-td> {{ tr.commission_date }} </vs-td>
          <!-- <vs-td> </vs-td> -->
        </vs-tr>
      </template>
    </vs-table>

    <vs-pagination v-model="page" :total="totalPages" :max="totalPages / length > 7 ? 7 : 9" class="mt-8"></vs-pagination>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'TagListTable',

  props: {
    tagType: {
      type: String,
      default: null
    },
    status: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      loading: false,
      page: 1,
      length: 10,
      order: [],
      search: null
    }
  },

  mounted() {
    // fetch tag list
    this.fetchTagList()
  },

  computed: {
    ...mapState('tags', ['tags', 'total', 'FilteredCount']),

    // set total pages for pagination
    totalPages() {
      return Math.ceil(this.FilteredCount / this.length)
    }
  },

  methods: {
    // fetch tag list
    fetchTagList() {
      this.loading = true
      this.$store.dispatch('tags/getTagList', { page: this.page, limit: this.length, order: this.order, search: this.search, tag_type: this.tagType, status: this.status }).finally(() => {
        this.loading = false
      })
    },

    addMoreTag() {
      this.loading = true
      this.$store
        .dispatch('tags/addNewTag', { type: this.tagType })
        .then(() => {
          this.loading = false
          this.fetchTagList()
        })
        .catch(message => {
          this.loading = false

          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },

    // handle page change
    handleChangePage(page) {
      this.page = page
      this.fetchTagList()
    },

    // handle change length
    handleChangeLength(length) {
      this.page = 1
      this.length = length
      this.fetchTagList()
    },

    // search
    updateSearchQuery(val) {
      this.page = 1
      this.search = val
      this.fetchTagList()
    }
  },

  watch: {
    loading() {
      if (this.loading) {
        this.$vs.loading({
          container: '#tag__table',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#tag__table > .con-vs-loading')
      }
    },

    page() {
      this.handleChangePage(this.page)
    }
  }
}
</script>
